import Select from 'react-select';
import { milestoneConstants } from '../../utils/constants';
import { useEffect } from 'react';

function NewAuditAreaInformation({
  auditAreaInfo,
  setNewAuditInfoUpdatedData,
  newAuditInfoUpdatedData,
  newAuditInfo,
  newAuditAreasError,
  enabled,
  isSubmitting,
  isSubmitted,
  setFlag,
  validateAuditInfoForNewAuditAreas,
}) {
  

  useEffect(() => {
    setNewAuditInfoUpdatedData((prev) => ({
      ...prev,
      [auditAreaInfo?.name]: {
        ...prev?.[auditAreaInfo?.name],
        feedbackCategoryId: auditAreaInfo?.id,
        total: newAuditInfo?.[`${auditAreaInfo?.name}`]?.AuditInfoFeedbackCategory?.totalCodes,
        correct: newAuditInfo?.[`${auditAreaInfo?.name}`]?.AuditInfoFeedbackCategory?.correctCodes,
        feedbackCategoryDropdown: {
          value: newAuditInfo?.[`${auditAreaInfo?.name}`]?.AuditInfoFeedbackCategory?.FeedbackCategoryDropdowns?.id,
          label: newAuditInfo?.[`${auditAreaInfo?.name}`]?.AuditInfoFeedbackCategory?.FeedbackCategoryDropdowns?.name
        }
      }
    }
    ));
    // eslint-disable-next-line
  }, [newAuditInfo]);

  const handleInputChange = (e, type) => {
    const value = parseInt(e.target.value);
    
    if (type === 'total') {
      setNewAuditInfoUpdatedData((prev) => ({
        ...prev,
        [auditAreaInfo?.name]: {
          ...prev?.[auditAreaInfo?.name],
          total: value,
          feedbackCategoryDropdown: value <= prev?.[auditAreaInfo?.name]?.correctCodes ? {} : (prev?.[auditAreaInfo?.name]?.feedbackCategory || {})
        }
      }
      ));
      const data = {...newAuditInfoUpdatedData, [auditAreaInfo?.name]: {
        ...newAuditInfoUpdatedData?.[auditAreaInfo?.name],
        total: value,
        feedbackCategoryDropdown: value <= newAuditInfoUpdatedData?.[auditAreaInfo?.name]?.correctCodes ? {} : (newAuditInfoUpdatedData?.[auditAreaInfo?.name]?.feedbackCategory || {})
      }}
      validateAuditInfoForNewAuditAreas(data);

    } if (type === 'correct') {
      setNewAuditInfoUpdatedData((prev) => ({
        ...prev,
        [auditAreaInfo?.name]: {
          ...prev?.[auditAreaInfo?.name],
          correct: value,
          feedbackCategoryDropdown: value >= prev?.[auditAreaInfo?.name]?.totalCodes ? {} : (prev?.[auditAreaInfo?.name]?.feedbackCategory || {})
        }
      }
      ));
      const data = {...newAuditInfoUpdatedData, [auditAreaInfo?.name]: {
        ...newAuditInfoUpdatedData?.[auditAreaInfo?.name],
        correct: value,
        feedbackCategoryDropdown: value >= newAuditInfoUpdatedData?.[auditAreaInfo?.name]?.totalCodes ? {} : (newAuditInfoUpdatedData?.[auditAreaInfo?.name]?.feedbackCategory || {})
      }}
      validateAuditInfoForNewAuditAreas(data);
    }   
    setFlag(true);
  }

  const renderFeedbackCategoryDropdownFields = () => auditAreaInfo?.FeedbackCategoryDropdowns?.map((item) => ({
    value: item?.id,
    label: item?.name
  }));

  const handleSelectChange = (val) => {
    setNewAuditInfoUpdatedData((prev) =>
    ({
      ...prev,
      [auditAreaInfo?.name]: {
        ...prev?.[auditAreaInfo?.name],
        feedbackCategoryDropdown: val,
      }
    }
    ));
    setFlag(true);
    const data = {...newAuditInfoUpdatedData, [auditAreaInfo?.name]: {
      ...newAuditInfoUpdatedData?.[auditAreaInfo?.name],
      feedbackCategoryDropdown: val
    }}
    validateAuditInfoForNewAuditAreas(data);

  };

  return (
    <tr key={auditAreaInfo?.id}>
      <td className="text-left pt-5">{auditAreaInfo?.name}</td>
      <td>
        <input
          type="number"
          min={0}
          className="form-control"
          disabled={!enabled || isSubmitted || isSubmitting || (newAuditInfo?.milestoneId ===
            milestoneConstants.AUDIT_IN_PROGRESS_MILESTONE_ID
            ? !enabled
            : true)}
          defaultValue={newAuditInfo?.[`${auditAreaInfo?.name}`]?.AuditInfoFeedbackCategory?.totalCodes}
          value={newAuditInfoUpdatedData?.[auditAreaInfo?.name]?.total}
          onChange={(e) => handleInputChange(e, 'total')}
        />
        {
          newAuditAreasError?.[`${auditAreaInfo?.name}`]?.totalCodes && (
            <p className="text-danger">{newAuditAreasError?.[`${auditAreaInfo?.name}`]?.totalCodes}</p>
          )
        }
      </td>
      <td>
        <input
          type="number"
          min={0}
          className="form-control"
          disabled={!enabled || isSubmitted || isSubmitting || (newAuditInfo?.milestoneId ===
            milestoneConstants.AUDIT_IN_PROGRESS_MILESTONE_ID
            ? !enabled
            : true)}
          defaultValue={newAuditInfo?.[`${auditAreaInfo?.name}`]?.AuditInfoFeedbackCategory?.correctCodes}
          value={newAuditInfoUpdatedData?.[auditAreaInfo?.name]?.correct}
          onChange={(e) => handleInputChange(e, 'correct')}
        />
        {
          newAuditAreasError?.[`${auditAreaInfo?.name}`]?.correctCodes && (
            <p className="text-danger">Required</p>
          )
        }
      </td>
      <td>
        {(parseInt(newAuditInfoUpdatedData?.[auditAreaInfo?.name]?.total) > parseInt(newAuditInfoUpdatedData?.[auditAreaInfo?.name]?.correct)) ? <Select
          options={renderFeedbackCategoryDropdownFields()}
          onChange={handleSelectChange}
          value={newAuditInfoUpdatedData?.[auditAreaInfo?.name]?.feedbackCategoryDropdown}
          isDisabled={
            !enabled || isSubmitted || isSubmitting ||
            (newAuditInfo?.milestoneId ===
              milestoneConstants.AUDIT_IN_PROGRESS_MILESTONE_ID
              ? !enabled
              : true)
          }
        />
          :
          <Select
            options={[]}
            isMulti={true}
            value={null}
            isDisabled={true}
          />}

        {
          newAuditAreasError?.[`${auditAreaInfo?.name}`]?.feedbackCategory && (
            <p className="text-danger">Required</p>
          )
        }

      </td>
    </tr>
  )
}

export default NewAuditAreaInformation